module.exports = __webpack_public_path__ + "img/br9.61b56b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br9.jpg
// module id = KAaL
// module chunks = 0